import { LOG_SWITCH_TO_DEFAULT_FILTER } from 'constants/logSwitchTo'
import LogSwitchToTypes from 'store/actionTypes/logSwitchTo'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  pagination: {},
  filter: LOG_SWITCH_TO_DEFAULT_FILTER
}

const logSwitchTo = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case LogSwitchToTypes.GET_LOG_SWITCH_TO_SUCCESS:
      return {
        ...state,
        list: payload?.items || [],
        pagination: payload?.meta || {}
      }
    case LogSwitchToTypes.UPDATE_FILTER_LOG_SWITCH_TO_SUCCESS:
      return { ...state, filter: payload }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default logSwitchTo
